exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".freeforms-margin-bottom{margin-bottom:20px}div#checkbox-styler.jq-checkbox.disabled,div.jq-radio.disabled,div.jq-selectbox__select.disabled,input[disabled],textarea[disabled]{cursor:not-allowed!important;background-color:#eee!important;opacity:1}div.jq-file__browse.ng-binding.ng-scope.disabled{cursor:not-allowed}.apply .wrapper .application .app-display .left-side .info .inputs p.subinfo{margin-top:15px}.report-field ::-webkit-scrollbar{-webkit-appearance:none;width:7px}.report-field ::-webkit-scrollbar-thumb:vertical{border-radius:5px;background-color:rgba(0,0,0,.5);-webkit-box-shadow:0 0 1px hsla(0,0%,100%,.5)}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ../~/css-loader!./directives/freeforms/freeformsWidget.css
// module id = 414
// module chunks = 0